module.exports = __webpack_public_path__ + "media/images/vp/parallax.temp.02-50c0a388ddcb37511fb0491599a1ef05.svg";